const IconWrapper = ({ children, ...rest }) => (
  <div
    className="cursor-pointer p-2 hover:bg-gray-200 rounded-full flex justify-center items-center"
    {...rest}
  >
    {children}
  </div>
)

export default IconWrapper
